export default __webpack_public_path__ + "static/media/image-main-1-m@2x.7daef8a5.webp";